import request from '@/utils/request';
import { ApiPrefix } from '@/constants/constants';
import { BsqyReqParamsType } from './type';

export default {
	/** 新建企业 */
	queryBsqyList: (params?: BsqyReqParamsType) => {
		return request({
			url: ApiPrefix.QyApiDefault + '/bsqy',
			method: 'GET',
			params,
		});
	},
	// 获取用户管理的企业信息
	queryUserQyList() {
		return request({
			url: ApiPrefix.QyApiDefault + '/qygl/qiye/list',
			method: 'GET',
		});
	},
};
